//src/components/forConsultantPhysiciansSolutionsData.js
import ReachNewPatients from '../assets/attract_more_patient.jpg';
import AtmosphereForPatients from '../assets/Enhance_your_patient_experience.jpg';
import FocusOnPatientCare from '../assets/Deliver_better_care.jpg';
import StreamlineYourPayments from '../assets/get_paid_faster.jpg';
import DataInDepth from '../assets/get_deeper_insights.jpg';
import ConsultantImplementation from '../assets/automate_your_practice.jpg';

const forConsultantPhysiciansSolutionsData = [
    {
        id: 1,
        title: "Reach new patients",
        text: "In a landscape where 69% of patients have visited a doctor in the past 12 months, it's crucial for your Consultant Physicians  practice to stand out. Doclivo simplifies the process, ensuring patients can easily find your family practitioners through search engine optimization and targeted digital marketing. Create a positive first impression with automated reputation management and polished online profiles, allowing patients to seamlessly connect with your practice.",
        image: ReachNewPatients,
        buttonLabel: "Learn more",
    },
    {
        id: 2,
        title: "Create a Welcoming Atmosphere for Patients",
        text: "Quality is the cornerstone of your Consultant Physicians  practice. With nearly 80% of patients willing to switch doctors for greater convenience, Doclivo brings modern convenience to the forefront. It ensures quick and easy appointment scheduling, timely responses to inquiries, effortless access to records, and straightforward billing. Back-end automation translates to front-end convenience without requiring additional effort from you.",
        image: AtmosphereForPatients,
        buttonLabel: "Learn more",
    },
    {
        id: 3,
        title: "Maintain Focus on Patient Care",       
        text: "Minimize tool management time. Our certified, cloud-based EHR seamlessly integrates provider scheduling, clinical notes, flowsheets, eRx, eLabs, telehealth, and more—all in one place. Leverage our mobile app to securely provide on-the-go care to your families.",
        image: FocusOnPatientCare,
        buttonLabel: "Learn more",
    },
    {
        id: 4,
        title: "Streamline Your Payments with Ease",
        text: "Eliminate frustration from medical billing and payments. Doclivo's billing and payments solutions make it easy for patients to understand and settle bills. Intuitively manage your independent family practice, save time with automation, and enhance your revenue cycle.",
        image: StreamlineYourPayments,
        buttonLabel: "Learn more",
    },
    {
        id: 5,
        title: "Explore Your Data in Depth",
        text: "Consultant Physicians  providers enhance care delivery with clear data insights. Doclivo provides instant access to analytics covering every aspect of your practice, from growth to revenue. Ensure security with HIPAA-compliant cloud storage and customize your data exploration with APIs that seamlessly integrate with third-party applications.",
        image: DataInDepth,
        buttonLabel: "Learn more",
    },
    {
        id: 6,
        title: "Effortless Implementation",
        text: "Switch seamlessly without disrupting your practice. Doclivo ensures an easy start with no requirement for IT expertise or complex processes. Our onboarding, training, and continuous support will guide you every step of the way, ensuring your Consultant Physicians  practice continues without missing a beat.",
        image: ConsultantImplementation,
        buttonLabel: "Learn more",
    },
    
   
    // Add more items as needed

];

export default forConsultantPhysiciansSolutionsData;